<template>
  <div class="flex flex-nowrap gap-24 p-24 overflow-x-auto">
    <template
      v-for="alternativa in alternativas"
      :key="alternativa.id"
    >
      <ItemAlternativaVertical
        :tipo-opcao
        :assessment
        :alternativa
        :title="alternativa.titulo"
        :description="alternativa.descricao"
        :color="respostas?.[alternativa.id]?.respostas?.at(-1)?.cor"
        @click:evidencia="$emit('click:evidencia', $event)"
      >
        <AlternativaOpcoesVertical
          :alternativa
          :respostas
          :tipo-opcao
          @click:opt="$emit('click:opt', $event)"
          @update:opt="$emit('update:opt', $event)"
        />
      </ItemAlternativaVertical>
    </template>
  </div>
</template>

<script setup>
import AlternativaOpcoesVertical from 'components/Alternativa/AlternativaOpcoesVertical.vue'
import ItemAlternativaVertical from 'components/PagePergunta/ItemAlternativaVertical.vue'

const props = defineProps({
  alternativas: Array,
  respostas: Object,
  tipoOpcao: Object,
  assessment: Object,
})

const emit = defineEmits([
  'click:evidencia',
  'click:opt',
  'update:opt',
])
</script>

<style lang="scss" scoped></style>
